export type PaginatedData<T> = {
	records: T[];
	metadata: {
		last: boolean;
		pageNumber: number;
		pageSize: number;
		pageNext: number | null;
		pagePrevious: number | null;
		totalPages: number;
		totalCount: number;
	};
};

export type PaginationParams<T extends Record<string, any>> = {
	page_number?: number;
	sort_by?: string;
	sort_direction?: string;
} & T;

export type RecordOrID = { id: string } | string;

export const ensureID = (record: RecordOrID): string => {
	return typeof record === 'string' ? record : record.id;
};

export class Metadata {
	last = false;
	pageNumber = 0;
	pageSize = 0;
	pageNext: number | null = null;
	pagePrevious: number | null = null;
	totalPages = 0;
	totalCount = 0;

	constructor(data: Partial<Metadata> = {}) {
		Object.assign(this, data);
	}
}

export const headers = {
	'Key-Inflection': 'camel',
};
